import { render, staticRenderFns } from "./catalog-item-small-desktop.vue?vue&type=template&id=6fd90c19"
import script from "./catalog-item-small-desktop.vue?vue&type=script&lang=js"
export * from "./catalog-item-small-desktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogItemHoverSlider: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-hover-slider.vue').default,CatalogItemTitle: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-title.vue').default,CatalogItemPrice: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-price.vue').default,CatalogItemTechList: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-tech-list.vue').default,CatalogItemButtons: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-buttons.vue').default})
